const departments = [
  {
    _id: 'CS',
    depName: 'Computer Science',
    HODName: 'Dr. Ahmed Ali',
  },
  {
    _id: 'EE',
    depName: 'Electrical Engineering',
    HODName: 'Dr. Fatima Khan',
  },
  {
    _id: 'ME',
    depName: 'Mechanical Engineering',
    HODName: 'Dr. Zaid Malik',
  },
  {
    _id: 'BA',
    depName: 'Business Administration',
    HODName: 'Dr. Aisha Hussain',
  },
  {
    _id: 'SE',
    depName: 'Software Engineering',
    HODName: 'Dr. Bilal Farooq',
  },
  {
    _id: 'ME',
    depName: 'Mechanical Engineering',
    HODName: 'Dr. Zaid Malik',
  },
  {
    _id: 'EE',
    depName: 'Electrical Engineering',
    HODName: 'Dr. Fatima Khan',
  },
  {
    _id: 'CE',
    depName: 'Civil Engineering',
    HODName: 'Dr. Imran Qureshi',
  },
];

export default departments;
